import React from "react";
import Header from "../component/Header";
import { Outlet } from "react-router-dom";

export default function Invoice() {
  const navbarMenu = [
    { name: "Proforma Invoice", pageNavigate: "/invoice/ProformaInvoiceView" },
    { name: "Invoice", pageNavigate: "/invoice" },
    { name: "Add Invoice", pageNavigate: "/invoice/addInvoice" },
  ];
  return (
    <>
      <div className="screen_mainContainer">
        <Header navbarMenu={navbarMenu} />
        <Outlet />
      </div>
    </>
  );
}
